export default __webpack_public_path__ + "static/media/info.2b4e36f0.svg";